import * as commands from '../commands';
import config from '@/services/config';
import user from '@/services/user';
import { IUserData} from '@/services/user';
import channel from '../channel';
import { CreateSubscriptionFromTrello, CreateSubscriptionFromTrelloResult } from '../remotecommands';
import { checkAccess, notifyAccessChanged } from '@/services/storiesonboardrepository';
import { flashError } from '@/services/helpers';

export var CreateSubscriptionFromTrelloLocaleHandler = async (t: ITrelloClient, obj: commands.CreateSubscriptionFromTrelloLocale): Promise<commands.SignUpToStoriesOnBoardResult> => {

    var result: CreateSubscriptionFromTrelloResult = await channel(t).sendCommand(new CreateSubscriptionFromTrello(
        obj.name,
        obj.email,
        obj.storymapName,
        obj.password,
        obj.isSubscribedToNewsletter,
        obj.needsHelpWith,
        obj.trelloApiToken,
        obj.epicNames,
        obj.listsToImport,
        obj.currentReleaseName,
        obj.currentReleaseDescription,
        obj.currentReleaseDeadline,
        obj.nextReleaseName,
        obj.statusMap,
        obj.exportingList,
        obj.personalAccessToken,
        obj.externalProjectId,
    ));

    if(result.IsSuccess) {
        var setupData = config(t).getDefaultConfigObject(result.IntegrationIdentifier);
        setupData.isCompleted = true;
        await config(t).set(setupData);
        var userData: IUserData = {
            trelloApiToken : obj.trelloApiToken,
            terlloUserId : obj.trelloUserId,
            trelloEmail : obj.trelloEmail,
            trelloFullName: obj.trelloFullName,
            trelloInitals: obj.trelloInitals,
            trelloUserName: obj.trelloUserName,
            stobApiToken: result.PersonalAccessToken
        };
        await user(t).set(userData);
    }
    else {
        t.alert({
            message: result.Message,
            duration: 15,
            display: 'error'
          });
    }

    return new commands.SignUpToStoriesOnBoardResult(result.IsSuccess, result.Message, result.StorymapUrl);
}


export var SetupOnExistingIntegration = async (t: ITrelloClient, n: commands.SetupOnExistingIntegration) : Promise<any> => {
    var cfg = await config(t).get();
    if (cfg == undefined) {
        cfg = config(t).getDefaultConfigObject(n.integrationIdentifier);
    }
    else {
        cfg.integrationId = n.integrationIdentifier;
    }
    cfg.isCompleted = true;
    await config(t).set(cfg);
    await user(t).setPersonalAccessToken(n.personaAcccessToken);
}

export var SetPersonalAccessTokenHandler = async (t: ITrelloClient, command: commands.SetPersonalAccessToken) : Promise<any> => {
    await user(t).setPersonalAccessToken(command.pat);
    await notifyAccessChanged(t);
}


export var UpdateSetupHandler = async (t: ITrelloClient, n: commands.UpdateSetup) : Promise<any> => {
    var c = await config(t).get();
    c.isEnableEditEstimation = n.isEnableEditEstimation;
    c.bigStoryLimit = n.bigStoryLimit;
    c.isMarkBigStoryCards = n.isMarkBigStoryCards;
    c.isStoryPointScaleValueCustomizable = n.isStoryPointScaleValueCustomizable;
    c.storyPointScale = n.storyPointScale;

    c.isShowAnnotations = n.isShowAnnotations;
    c.isShowAnnotationsOnCardBack = n.isShowAnnotationsOnCardBack;
    c.isShowAnnotationsOnCardFront = n.isShowAnnotationsOnCardFront;

    c.isShowCardContext = n.isShowCardContext;
    c.isShowCardContextGoalOnCardFront = n.isShowCardContextGoalOnCardFront;
    c.isShowCardContextOnCardBack = n.isShowCardContextOnCardBack;
    c.isShowCardContextStepOnCardFront = n.isShowCardContextStepOnCardFront;

    c.isShowEstimation = n.isShowEstimation;
    c.isShowEstimationOnCardBack = n.isShowEstimationOnCardBack;
    c.isShowEstimationOnCardFront = n.isShowEstimationOnCardFront;

    c.isShowReleases = n.isShowReleases;
    c.isShowReleasesOnCardBack = n.isShowReleasesOnCardBack;
    c.isShowReleasesOnCardFront = n.isShowReleasesOnCardFront;

    c.isShowStoryAttachemtns = n.isShowStoryAttachemtns;
    c.selectedAnnoatations = n.selectedAnnotations;
    await config(t).set(c);
}


export var DisablePowerUpHandler = (t: ITrelloClient, n: commands.DisablePowerUp) : Promise<any> => {
    return new Promise(resolve => {
        config(t).get().then(cfg => {
            cfg.isCompleted = false;
            config(t).set(cfg).then(() => {
                user(t).removeUserData().then(() => {
                    resolve();
                })
            })
        })
    });
}
